import { render, staticRenderFns } from "./InventoriesRefillsTable.vue?vue&type=template&id=70298845&scoped=true"
import script from "./InventoriesRefillsTable.vue?vue&type=script&lang=js"
export * from "./InventoriesRefillsTable.vue?vue&type=script&lang=js"
import style0 from "./InventoriesRefillsTable.vue?vue&type=style&index=0&id=70298845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70298845",
  null
  
)

export default component.exports